import { useEffect, useState } from "react";
import { usePracticePerms } from "./context/PracticePermissionsContext";
import { AnimatePresence } from "framer-motion";
import { MemberPermissionModal } from "./modals/PracticePermissionsModal";
import { UserWithPracticePermissions, FULL_PERMISSIONS } from "./PracticePermissions.types";

export function PracticePermissionsList() {
  const { memberPermissions, refresh } = usePracticePerms();
  const [memberToEdit, setMemberToEdit] = useState<UserWithPracticePermissions | undefined>();

  useEffect(() => {
    refresh()
  }, [])

  const headers = [
    { value: "name", label: "Member Name" },
    { value: "email", label: "Email" },
    { value: "permissions", label: "Permissions" },
  ]

  return (<>
    <div className="mb-5 flex gap-5 flex-col md:flex-row justify-between md:items-center">
      <div className="text-black text-3xl font-bold">Manage Practice Members</div>
      <div className="flex justify-center"></div>
    </div>
    <div className="bg-white rounded-lg shadow-[10px_14px_40px_0px_rgba(0,71,28,0.04)] p-5">
      <div
        className={`mt-3 text-[14px] h-[calc(100vh-232px)] overflow-auto`}
      >
        <table className="w-full">
          <thead className="[&_td]:bg-[#EEF1EF] [&_td]:py-4">
            <tr className="sticky top-0 z-[1]">
              {headers.map((header, i) => (<td key={i} className={i === 0 ? "rounded-l pl-5" : ""}>
                <div className="flex items-center cursor-pointer">
                  {header.label}
                </div>
              </td>))}
            </tr>
          </thead>
          <tbody>
            {memberPermissions?.map((member) => (
              <tr
                key={member.id}
                className="cursor-pointer hover:bg-[#F9F9F9] [&_td]:py-3 border-b border-b-[#EFF1FF]"
                onClick={() => setMemberToEdit(member)}
              >
                <td className="name pl-5">
                  <div className="flex items-center gap-3">
                    <div className="flex flex-col">
                      <div className="flex items-center gap-2.5">
                        <div className="inline-block overflow-none">
                          {member?.name}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  {member.email}
                </td>
                <td>
                  {member.permissions.length === FULL_PERMISSIONS.length ? 'FULL ACCESS' : `${member.permissions.length} Permissions`}
                </td>
              </tr>
            ))}

          </tbody>
        </table>
      </div>
    </div>
    {
      memberToEdit && <MemberPermissionModal member={memberToEdit} onClose={
        () => {
          refresh();
          setMemberToEdit(undefined);
        }}
      />
    }
  </>)
};
